import { useRef, useCallback } from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import useGCLID from './gclid';

export default function useElementViewed<T extends HTMLElement>(
  observerThreshold = 0.5
): React.RefObject<T | null> {
  const ref = useRef<T>(null);
  const gclid = useGCLID();

  // Memoize the callback to prevent observer recreation on re-renders
  const handleIntersection = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        analytics.track('Element Viewed', {
          gclid,
          elementPosition: entry.target.getAttribute('data-element-position'),
          elementName: entry.target.getAttribute('data-element-name'),
          elementType:
            entry.target.getAttribute('data-element-type') ??
            entry.target.tagName.toUpperCase(),
          url: window.location.href,
          path: window.location.pathname,
        });
      });
    },
    [gclid]
  );

  useIntersectionObserver(
    { refs: [ref], options: { threshold: observerThreshold }, once: true },
    handleIntersection // Use memoized callback instead of inline function
  );

  return ref;
}
